import React from 'react';
import PropTypes from 'prop-types';
import { X_AXIS_TICKS_BUFFER } from './defaults.jsx';

export const XAxisTicks = ( props ) => {
    const { x, text, style, textAnchor } = props;
    return (
        <text textAnchor={ textAnchor } x={ x } y={ X_AXIS_TICKS_BUFFER } style={ style }>{ text }</text>
    );
};

XAxisTicks.propTypes = {
	x: PropTypes.number,
	text: PropTypes.string,
	style: PropTypes.object,
	textAnchor: PropTypes.string
};

export default XAxisTicks;